<template>
    <div>
        <el-dialog :visible.sync="dialogVisible"  width="600px" :close-on-press-escape='false' :close-on-click-modal="false" @close="showModal(false)">
            <template slot="title">
                <div style="text-align: center;">
                    <div><img style="width: 80px;" src="../assets/logo.png"></div>
                    <div class="title mainColor">{{$t('view.欢迎登录信翼通招标网') }}</div>
                </div>
            </template>
            <el-form ref="loginForm" label-width="100px"  style="margin: 0 auto ;" :model="loginForm" :rules="loginRules">
                <el-form-item prop="username">
                    <el-input style="width: 360px;" v-model="loginForm.username" :placeholder="$t('view.请输入账号/手机号')"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input style="width: 360px;" :placeholder="$t('view.请输入密码')" v-model="loginForm.password" show-password></el-input>
                </el-form-item>
                <div style="text-align: center;margin: 20px 0;">
                    <el-button style="width: 360px;" type="primary" @click="login ">{{ $t('view.立即登录') }}</el-button>
                </div>
                <div style="display: flex;justify-content: space-between;width: 360px;margin: 30px auto;font-size: 14px;">
                    <el-checkbox v-model="rememberMe" style="color: #999; font-size: 12px;">{{ $t('view.记住密码') }}</el-checkbox>

                    <span style="cursor: pointer;" class="mainColor" @click="Jump('forgotPassword')">{{ $t('view.忘记密码') }}</span>
                
                </div>
                <div style="text-align: center;">
                        <span style="color: #666666;">{{ $t('view.还没账号？') }}</span>
                        <span style="cursor: pointer;" class="mainColor" @click="Jump('Register')">{{$t('view.立即注册')}}</span>
                </div>
            </el-form>
 
        </el-dialog>
    </div>
  </template>

<script>
    import Cookies from "js-cookie";
    import { encrypt, decrypt } from '@/utils/jsencrypt'
  export default {
    data(){
      return{
        dialogVisible:false,
        rememberMe:false,
        loginForm:{
            username: '',
            password:''
        },
        loginRules:{
            username: [
                { required: true, trigger: 'blur',  message: this.$t('view.请输入')}
            ],
            password: [
                { required: true, trigger: "blur", message: this.$t('view.请输入') }
            ],
        }
      }
    },
    watch:{
        '$store.state.user.ModalShow': {
            //深度监听，可监听到对象、数组的变化
            handler(val,oldVal) {
                this.dialogVisible=val
                
            },
            deep: true, //true 深度监听
        },
    },
    methods:{
        showModal(Boolean){
            this.$store.commit('showUnauthorizedModal',Boolean)
        },
        Jump(url){
            this.$router.push(url)
        },
        // 登录
        login(){
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    if (this.rememberMe) {
                        Cookies.set("username", this.loginForm.username, { expires: 30 });
                        Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
                        Cookies.set('rememberMe', this.rememberMe, { expires: 30 });
                    } else {
                        Cookies.remove("username");
                        Cookies.remove("password");
                        Cookies.remove('rememberMe');
                    }
                    this.loginForm.username= this.loginForm.username.replace(/\s*/g, "")
                    this.$store.dispatch("Login", this.loginForm).then(res=>{
                        if(res.code==200){
                            this.$store.dispatch('GetInfo').then(res=>{
                                this.dialogVisible = false
                                if(this.$route.name=='forgotPassword'){
                                    this.$router.push('/')
                                }else{
                                    location.reload()
                                }

                            })
                        }

                    })

                }
            })
        },
        init(){
            this.dialogVisible=true

            if (Cookies.get('rememberMe')) {
                this.loginForm.username=Cookies.get('username')
                this.loginForm.password=decrypt(Cookies.get('password'))  
                Cookies.remove("username");
                Cookies.remove("password");
                Cookies.remove('rememberMe');
            }
        },
        handleClose(){
            this.dialogVisible=false
        },
    }
  };
  </script>
  <style scoped>
  .title{
    font-size: 24px;
    line-height: 28px;

  }
  </style>
